import {
  $createParagraphNode,
  $isDecoratorNode,
  $isElementNode,
  LexicalNode,
} from 'lexical';

/**
 * root 에 직접 붙일 노드 배열의 최상위 인라인 노드를 문단으로 감싼다.
 * root 는 element/decorator 만 받으므로(블록 태그 없는 HTML → $generateNodesFromDOM
 * 결과 최상위가 텍스트) 그대로 넣으면 Lexical #282(rootNode.splice) 로 전체 크래시.
 * 인라인 element(LinkNode 등)도 root 직하에 놓이면 구조가 깨지므로 isInline 기준으로 묶음.
 * 연속된 인라인은 하나의 문단. root.append 직삽입 경로 전용 — RangeSelection.insertNodes
 * 는 자체 처리하므로 그 경로에 쓰면 문단 중간 붙여넣기가 새 문단으로 갈라짐.
 */
export const $wrapTopLevelInlines = (nodes: LexicalNode[]): LexicalNode[] => {
  const blocks: LexicalNode[] = [];
  let inlineBuffer: LexicalNode[] = [];
  const flushInline = () => {
    if (inlineBuffer.length === 0) return;
    const paragraph = $createParagraphNode();
    paragraph.append(...inlineBuffer);
    blocks.push(paragraph);
    inlineBuffer = [];
  };
  nodes.forEach((node) => {
    const isBlock =
      ($isElementNode(node) || $isDecoratorNode(node)) && !node.isInline();
    if (isBlock) {
      flushInline();
      blocks.push(node);
    } else {
      inlineBuffer.push(node);
    }
  });
  flushInline();
  return blocks;
};
